export const gitMetadata = {
    "commitHash": "6973b0ccc40f41aff15046cb8fe5d3e30cf6ee23",
    "commitHashShort": "6973b0c",
    "branch": "main",
    "isDirty": false,
    "buildTime": "2026-11-05T12:01:56.026Z"
};
//# sourceMappingURL=versionData.js.map